import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Package, 
  ShoppingCart, 
  Users, 
  FileText, 
  Tag, 
  Settings,
  LogOut,
  Upload,
  Bookmark,
  FolderTree,
  Home,
  UsersRound
} from 'lucide-react';

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/admin' },
    { icon: Home, label: 'Homepage', path: '/admin/homepage' },
    { icon: Package, label: 'Products', path: '/admin/products' },
    { icon: FolderTree, label: 'Categories', path: '/admin/categories' },
    { icon: Bookmark, label: 'Brands', path: '/admin/brands' },
    { icon: Upload, label: 'Bulk Upload', path: '/admin/bulk-upload' },
    { icon: ShoppingCart, label: 'Orders', path: '/admin/orders' },
    { icon: Users, label: 'Customers', path: '/admin/customers' },
    { icon: FileText, label: 'Blog', path: '/admin/blog' },
    { icon: Tag, label: 'Promo Codes', path: '/admin/promo-codes' },
    { icon: Settings, label: 'Settings', path: '/admin/settings' }
  ];

  return (
    <div className="flex h-screen bg-[#0A0A0A]">
      {/* Sidebar */}
      <aside className={`${
        isSidebarOpen ? 'w-64' : 'w-20'
      } bg-[#141414] border-r border-[#D4AF37]/20 transition-all duration-300`}>
        <div className="p-6">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 bg-gradient-to-br from-[#D4AF37] to-[#B8960C] rounded-lg flex items-center justify-center shadow-lg shadow-[#D4AF37]/30">
              <span className="text-[#0A0A0A] text-lg font-bold font-heading">B</span>
            </div>
            {isSidebarOpen && (
              <div>
                <h2 className="font-bold text-white font-heading">BOXVERRA</h2>
                <p className="text-xs text-[#D4AF37] font-body font-medium">Admin Panel</p>
              </div>
            )}
          </div>

          <nav className="space-y-1">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-[#D4AF37] text-[#0A0A0A] shadow-md shadow-[#D4AF37]/30'
                      : 'text-[#888888] hover:bg-[#1A1A1A] hover:text-white'
                  }`}
                >
                  <Icon className="h-5 w-5 flex-shrink-0" />
                  {isSidebarOpen && <span className="font-body font-medium">{item.label}</span>}
                </Link>
              );
            })}
          </nav>

          <div className="absolute bottom-6 left-6">
            <Link 
              to="/admin/login"
              onClick={() => localStorage.removeItem('admin_token')}
              className="flex items-center gap-3 px-4 py-3 text-[#888888] hover:text-[#D4AF37] transition-colors"
            >
              <LogOut className="h-5 w-5" />
              {isSidebarOpen && <span className="font-body font-medium">Sign Out</span>}
            </Link>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto bg-[#0A0A0A]">
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
